$(document).on("ready", function(){
  var collapsible = $(".collapsible");
  
  collapsible.each(function(item) {
    $(this).click(function(){
      $(this).toggleClass("active");
      var content = $(this).next();
      if(content.height()){
      	content.height(0);
        content.css({background:"trasparent"});
      }else{
      	content.height(content.prop('scrollHeight'));
        content.css({background:"#fff"})
      }
    });
  });

    var collapsible2 = $(".collapsible2");
  
  collapsible2.each(function(item) {
    $(this).click(function(){
      $(this).toggleClass("active");
      var content = $(this).next();
      if(content.height()){
      	content.height(0);
        content.css({background:"trasparent"});
      }else{
      	content.height(content.prop('scrollHeight'));
        content.css({background:"#555b67"})
      }
    });
  });
  
  //If we resize the window hide the Dropdowns
  $(window).resize(function(){
    collapsible.each(function(item){
      $(this).removeClass("active");
      var content = $(this).next();
      content.height(0);
      content.css({background:"trasparent"});
    })  	
  })
  //Related Products Section JS -- Custom Product Pages
  
  	var RelatedProductsJSON = $("#relatedProductsJSON");
  	var RelatedProductsCarousel = $("#products-grid-owl-carousel");
    var RelatedProductsContainer = $(".related-products");


    if(!RelatedProductsContainer[0])return;
  
    if(!RelatedProductsJSON[0]){
      RelatedProductsContainer[0].style.display = "none";
      return;
    }
  
    function RelatedProductCard(json){
      const productJson = JSON.parse(json);	
  	  
      if(productJson.length < 5){
      	$(".related-products button")[0].style.display = "none"
      }
      
      productJson.filter(product => { 
		const ProductCard = `
		<div class="grid-item col-md-6 pt-0">
		  <a href="${product.url}" class="td-none">
		  	<div class="related-card-container">
              <div class="related-card">
				<div class="related-card-header">
					<img loading="lazy" src="${product.image}" alt="${product.title}" />
                </div>
				<div class="related-card-body">
				  <h6 class="subheading m-0 p-0">
					 ${product.vendor}
				  </h6>
				  <h6 class="m-0 fw-bold p-0">${product.title}</h6>
				  <h6 class="mt-1">${product.price}</h6>
 				</div>
              </div>
            </div>
          </a>
		</div>
		`;
        
        RelatedProductsCarousel.append(ProductCard);
      })
    }
  
  	RelatedProductCard(RelatedProductsJSON[0].innerHTML);
  	
    $(".related-products .products-grid").owlCarousel({ 
      pagination: false,
      navigation: true,
      items: 3,
      itemsDesktop:[1300, 3],
 	  itemsDesktopSmall: [1024, 2],
      itemsTablet: [768, 2],
      itemsTabletSmall: [640, 1],
      itemsMobile : [479, 1]
    });
});


  (function () {

    var links = document.links;
    for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
      if (links[i].hostname !== window.location.hostname) {
        links[i].target = '_blank';
        links[i].rel = 'noreferrer noopener';
      }
    }
  
  })();